import mitt from 'mitt'

export type EventsBus = {
  'login-success': undefined
  /** 系统余额或提醒阈值发生变化，需要刷新余额预警悬浮框 */
  'balance-changed': undefined
}

const eventBus = mitt<EventsBus>()

export default eventBus
